export { default, getServerSideProps } from '~/pages/item'
